enum HttpHeader {
    AUTHORIZATION = 'Authorization',
}

export default HttpHeader;
